import { defineComponent as _defineComponent } from 'vue'
import CardContainer from '@/components/card-container.vue';
import { useGlobalBi } from '@/hooks/use-global-bi';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { language } from '@tencent/ppd-base-libs';
import { WePoints } from '@tencent/wphk-components-we-points';
import { ref, toRefs } from 'vue';
import { DP_PAGE } from '@/config/dp-config';
import { WE_POINTS_DP_POSITION } from '@/config/wepoint-config';
import { checkIsInSpring } from './ business/spring';
import { ModuleName } from '@/types/module-config';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['initDone'],
  setup(__props, { emit }) {

const isLoadSuccess = ref(true);
const lang = language.getLanguage();

const { isNeedShowAct, spId } = toRefs(useMerchantInfo());
const { getBiExt } = useGlobalBi();

// 判断是否在spring
const isInSpring = checkIsInSpring();

const handleInitDone = (status: 'fail' | 'success') => {
  const commonEmitMsg = {
    status,
    moduleName: ModuleName.wePointsModule,
  };
  if (!status || status === 'fail') {
    emit('initDone', commonEmitMsg);
    isLoadSuccess.value = false;
    return;
  }
  emit('initDone', { ...commonEmitMsg });
};

return { __sfc: true,isLoadSuccess, lang, emit, isNeedShowAct, spId, getBiExt, isInSpring, handleInitDone, CardContainer, WePoints, DP_PAGE, WE_POINTS_DP_POSITION }
}

})